import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Grid, Stack, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import dayjs from "dayjs";
import './Vehicle.css';
import blockHelper from "./../../images/block-helper.png";
import { useTranslation } from "react-i18next";

const MaintenaceModal = (props: any) => {
  const closeModal = props.closeModal;
  const maintenaceDataArray = props.maintenaceDataArray;
  let planeString = props.maintenaceData.plate;
  let vinString = props.maintenaceData.vin;
  const { t } = useTranslation(["operation"]);

  const cancel = () => {
    closeModal(false);
  };

  return (
    <Box className="dialogClass">
      <Dialog
        PaperProps={{
          sx: {
            minWidth: "899px",
          },
        }}
        open={true}
        aria-labelledby="draggable-dialog-title"
        maxWidth={"md"}
      >
        <DialogTitle
          className="dialogTitleClass"
          style={{ cursor: "move" }}
          id="draggable-dialog-title"
        >
          <Grid
            container
            alignItems="center"
            alignContent="center"
            direction="row"
          >
            <Grid className="maintenanceString" style={{ width: 479 }}>
              {t("carMaintenance.mainTitle.title")}
            </Grid>
            <Grid xs item>
              <Box>&nbsp;</Box>
            </Grid>

            <Grid item className="plateVimClass">
              {t("carMaintenance.filterAndSearch.plate")}{" "}
              <span style={{ fontWeight: 700 }}>{planeString}</span> -{" "}
              {t("carMaintenance.filterAndSearch.VINfield")}{" "}
              <span style={{ fontWeight: 700 }}>{vinString}</span>
            </Grid>

            <Grid xs item sx={{ justifyContent: "flex-end", display: "flex" }}>
              <IconButton className="cancelIconClass">
                <CloseIcon onClick={cancel} />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent dividers style={{ padding: "0" }}>
          {maintenaceDataArray.length > 0 ? (
            <Table aria-label="custom pagination table">
              <TableBody>
                {maintenaceDataArray.map((row: any) => (
                  <TableRow key={row.id}>
                    <TableCell style={{ height: 40, width: 300 }}>
                      <Grid xs item>
                        <Typography className="tabelElement">
                          {t("vehicle.maintenanceModal.date")}{" "}
                          <span style={{ fontWeight: 600 }}>
                            {dayjs
                              .utc(`${row.maintenanceDate}`)
                              .format("DD/MM/YYYY HH:mm")}
                          </span>
                        </Typography>
                      </Grid>
                    </TableCell>
                    <TableCell style={{ height: 40, width: 300 }}>
                      <Grid xs item>
                        <Typography className="tabelElement">
                          {" "}
                          {t("vehicle.maintenanceModal.km")}{" "}
                          <span style={{ fontWeight: 600 }}>
                            {row.kmMaintenance}
                          </span>
                        </Typography>
                      </Grid>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="center"
              spacing={3}
              className="vehicleNoMaintenanceBox"
            >
              <Box>
                <img src={blockHelper} alt="no-item" width="45" height="45" />
              </Box>
              <Box>
                <Stack
                  direction="column"
                  spacing={1}
                  alignItems="flex-start"
                  className="vehicleNoMaintenanceBoxText"
                >
                  <span>
                    {t("vehicle.maintenanceModal.noVehicleMaintenanceMessage1")}{" "}
                    <br />
                    {t("vehicle.maintenanceModal.noVehicleMaintenanceMessage2")}
                  </span>
                </Stack>
              </Box>
            </Stack>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};
export default MaintenaceModal;
